import { Avatar, Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import * as ROUTES from '../../../../router/Routes';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allEquiposAction,
  deleteEquiposAction,
  setActivoEquiposAction,
} from '../EquiposAction';
import { PARAMS_EQUIPOS } from '../EquiposReducer';
import ExpandedEquiposComponent from './ExpandedEquipos';

const ListadoEquipos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();
  let history = useHistory();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const equiposStore = Redux.useSelector((state) => state.equipos);
  const torneosStore = Redux.useSelector((state) => state.torneos);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...equiposStore.params,
        idEntidad: entidadesStore.activo.id,
        idTorneo: torneosStore.activo?.id,
      };
      dispatch({ type: PARAMS_EQUIPOS, payload });
      await allEquiposAction(dispatch, payload);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rowsData = [];
    equiposStore.all.forEach((el) => {
      rowsData.push({
        ...el,
        estatus: el.estatus.nombre,
      });
    });
    setRows(rowsData);
  }, [equiposStore.all]);

  const _handleEditClick = async (id) => {
    const data = equiposStore.all.find((el) => el.id === id);
    await setActivoEquiposAction(dispatch, data);
    history.push(ROUTES.panelEquipos.to);
  };

  async function _onDeleteHandler() {
    setLoadingDelete(true);
    await deleteEquiposAction(
      { dispatch, notify },
      equiposStore.activo.id,
      equiposStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  }

  function getDataStore(id) {
    return equiposStore.all.find((el) => el.id === id);
  }

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.imagen.name,
      label: CONST.imagen.label,
      width: '10%',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Avatar
              alt={value.nombre}
              sx={{ width: 40, height: 40 }}
              src={getFilesArchivos(value)}
            />
          );
        },
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.entrenador.name,
      label: CONST.entrenador.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row" spacing={1} alignItems="center">
              <Avatar
                alt={value.perfil.avatar?.nombre}
                sx={{ width: 40, height: 40 }}
                src={getFilesArchivos(value.perfil.avatar)}
              />
              <Typography>
                {value.perfil.pnombre.toUpperCase()}{' '}
                {value.perfil.papellido.toUpperCase()}
              </Typography>
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.lider.name,
      label: CONST.lider.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? (
            <Stack direction="row" spacing={1} alignItems="center">
              <Avatar
                alt={value.jugador.perfil.avatar.nombre}
                sx={{ width: 40, height: 40 }}
                src={getFilesArchivos(value.jugador.perfil.avatar)}
              />
              <Typography>
                {value.jugador.perfil.pnombre.toUpperCase()}{' '}
                {value.jugador.perfil.papellido.toUpperCase()}
              </Typography>
            </Stack>
          ) : (
            <Chip label="Sin Líder" size="small" color="error" />
          );
        },
      },
    },
    {
      name: CONST.deporte.name,
      label: CONST.deporte.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography
            // onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value.nombre}
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={value === 'ACTIVO' ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <BotonComponent
                click={async () => {
                  await setActivoEquiposAction(
                    dispatch,
                    getDataStore(tableMeta.rowData[0]),
                  );
                  history.push(ROUTES.panelEquipos.to);
                }}
                icon
                size="medium"
                transparentBg
                dashboardIcon
                tooltip="Panel del equipo"
              />
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={() => {
                  setActivoEquiposAction(
                    dispatch,
                    getDataStore(tableMeta.rowData[0]),
                  );
                  setOpenModalDelete(true);
                }}
                onDownload={() => {
                  window.open(value.url);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      const data = equiposStore.all.find((el) => el.id === rowData[0]);
      return <ExpandedEquiposComponent data={data} rowData={rowData} />;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={equiposStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title="Listado"
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {equiposStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">{equiposStore.activo.nombre}</Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoEquipos;
